export const ROUTE_HOME = "/";

export const ROUTE_BREADCRUMBS = {
  [ROUTE_HOME]: {
    parents: null,
    title: "drawer.home",
  },
};
